import type { SolutionTag } from '@cognite/solution-tags';

import type {
  APMAsset,
  ChecklistItem,
  ChecklistItemResponseType,
  CogniteSourceable,
  DirectRelationship,
  InFieldUser,
} from '../types';

const CHECKLIST_STATUSES = ['Ready', 'In progress', 'Done', 'Planned'] as const;

export type ChecklistStatus = (typeof CHECKLIST_STATUSES)[number];

const CHECKLIST_STATUS_SET = new Set<string>(CHECKLIST_STATUSES);

export const isChecklistStatus = (value: unknown): value is ChecklistStatus =>
  typeof value === 'string' && CHECKLIST_STATUS_SET.has(value);

export type Checklist = {
  sourceId?: string;
  title?: string;
  description?: string;
  type?: string;
  status?: ChecklistStatus;

  startTime?: string;
  endTime?: string;

  rootLocation?: APMAsset;
  assignedTo?: string[];
  checklistItems?: ChecklistItem[];

  isArchived?: boolean;
  solutionTags?: SolutionTag[];

  /** @deprecated Use sourceCreatedUser instead */
  createdBy?: InFieldUser;
  /** @deprecated Use sourceUpdatedUser instead */
  updatedBy?: InFieldUser;
  /** @deprecated Use sourceCreatedTime instead */
  createdTime?: number;
  /** @deprecated Use sourceUpdatedTime instead */
  lastUpdatedTime?: number;
} & CogniteSourceable;

export type ChecklistUpsertType = Omit<
  Checklist,
  'rootLocation' | 'createdBy' | 'updatedBy' | 'solutionTags'
> & {
  rootLocation?: DirectRelationship;
  createdBy?: DirectRelationship;
  updatedBy?: DirectRelationship;
  solutionTags?: DirectRelationship[];
};

export type ChecklistResponseType = Omit<
  Checklist,
  'checklistItems' | 'solutionTags'
> & {
  checklistItems?: {
    items?: ChecklistItemResponseType[];
    pageInfo?: { endCursor: string; hasNextPage: boolean };
  };
  solutionTags?: {
    items?: SolutionTag[];
  };
};
